import moment from "moment";
import React from "react";
import {
  UserOutlined,
  CalendarOutlined,
  IdcardOutlined,
  ColumnHeightOutlined,
  DashboardOutlined,
  HeartOutlined,
} from "@ant-design/icons";

interface PatientInfoData {
  fullname?: string;
  dateOfBirth?: string;
  gender?: string;
  height?: string | number;
  weight?: string | number;
  bloodGroup?: string;
}

export default function PatientInfo({ data }: { data: PatientInfoData }) {
  const fields: {
    icon: React.ReactNode;
    label: string;
    value: string;
    capitalize?: boolean;
  }[] = [
    { icon: <UserOutlined />, label: "Name", value: data.fullname || "n/a" },
    {
      icon: <CalendarOutlined />,
      label: "Birth date",
      value: data.dateOfBirth
        ? moment(data.dateOfBirth).format("Do MMMM YYYY")
        : "n/a",
    },
    {
      icon: <IdcardOutlined />,
      label: "Gender",
      value: data.gender || "n/a",
      capitalize: true,
    },
    {
      icon: <ColumnHeightOutlined />,
      label: "Height",
      value: data.height ? `${data.height} cm` : "n/a",
    },
    {
      icon: <DashboardOutlined />,
      label: "Weight",
      value: data.weight ? `${data.weight} kg` : "n/a",
    },
    {
      icon: <HeartOutlined />,
      label: "Blood group",
      value: data.bloodGroup || "n/a",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-3 p-4 sm:grid-cols-2">
      {fields.map((f) => (
        <div
          key={f.label}
          className="flex items-center gap-3 rounded-xl border border-slate-100 bg-slate-50/60 px-4 py-3"
        >
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-primary-blue shadow-sm">
            {f.icon}
          </div>
          <div className="min-w-0">
            <p className="m-0 text-xs text-slate-500">{f.label}</p>
            <p
              className={`m-0 truncate text-sm font-medium text-slate-800 ${
                f.capitalize ? "capitalize" : ""
              }`}
            >
              {f.value}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
